import { Component } from '@angular/core';
import { NavMenuItems } from 'pm-src/app/modules/header/nav-menu/nav-menu-items';

@Component({
    selector: 'app-nav-menu',
    templateUrl: './nav-menu.component.html',
    styleUrls: ['./nav-menu.component.scss'],
})
export class NavMenuComponent {
    public menuItems: any[];

    constructor() {
        this.menuItems = NavMenuItems;
    }
}
